import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'antd';
import TagView from 'components/TagView';

const CreateTagView = ({
  tagId,
  description,
  value,
  color,
  onClick,
  timestamp,
  unit,
}) => (
  <TagView
    tagId={tagId}
    description={description}
    value={value}
    color={color}
    onClick={onClick}
    timestamp={timestamp}
    unit={unit}
  />
);

CreateTagView.propTypes = {
  tagId: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  timestamp: PropTypes.number.isRequired,
  unit: PropTypes.string,
};

CreateTagView.defaultProps = {
  unit: '',
};

const ChartLegends = ({
  tags,
  colors,
  onClick,
  legendValues,
  hiddenSeries,
}) => {
  const dataSource = tags.filter(t => !hiddenSeries[t.value]).map(t => ({
    value: legendValues[t.value] ? legendValues[t.value].value : 0,
    timestamp: legendValues[t.value] ? legendValues[t.value].timestamp : 0,
    tagId: t.value,
    description: t.label || t.value,
    key: t.value,
    color: colors[t.value],
    unit: t.engunit,
    onClick: () => onClick(t.value),
  }));
  return <List dataSource={dataSource} renderItem={CreateTagView} />;
};

ChartLegends.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  colors: PropTypes.objectOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
  legendValues: PropTypes.objectOf(PropTypes.object),
  hiddenSeries: PropTypes.objectOf(PropTypes.bool).isRequired,
};

ChartLegends.defaultProps = {
  legendValues: {},
};

export default ChartLegends;



// WEBPACK FOOTER //
// ./src/components/ChartLegend/ChartLegend.js